{
  "appName": "AirPlx",
  "logoAlt": "AirPlx-Logo",
  "errors": {
    "authRequired": "Benutzerauthentifizierung erforderlich",
    "loginAgain": "Bitte melde dich erneut an, um Einladungen anzunehmen",
    "serviceUnavailable": "Dienst nicht verfügbar",
    "serviceTemporarilyUnavailable": "Dienst vorübergehend nicht verfügbar. Bitte versuche es erneut.",
    "emailRequired": "E-Mail erforderlich",
    "emailRequiredValidation": "E-Mail-Adresse ist erforderlich, um die Einladung zu bestätigen",
    "inviteInvalid": "Einladung ist nicht mehr gültig oder wurde bereits eingelöst",
    "invalidFBOInfo": "Ungültige FBO-Informationen in der Einladung",
    "inviteCouldNotBeClaimed": "Einladung konnte nicht eingelöst werden",
    "acceptFailed": "Einladung konnte nicht angenommen werden"
  },
  "inviteStatus": {
    "pending": "Ausstehend",
    "accepting": "Wird akzeptiert...",
    "tryAgain": "Nochmal",
    "accept": "Annehmen"
  }
}
